/* Copyright (c) 2023 TORITI */

import Request from './request';

export default class User {
  static async getListRoles(data = {}) {
    return new Promise((resolve) => {
      Request.send({
        method: 'get',
        path: 'user/getListRole',
        data
      }).then((result = {}) => {
        const { data } = result;
        return resolve({ isSuccess: true, data });
      });
    });
  }

  static async uploadAvatar(data = {}) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: 'common/upload',
        data
      }).then((result = {}) => {
        const { data } = result;
        return resolve({ isSuccess: true, data });
      });
    });
  }

  static async create(data = {}) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: 'admin/users',
        data
      }).then((result = {}) => {
        console.log('User create response:', result);
        return resolve(result);
      }).catch((error) => {
        console.error('User create error:', error);
        return resolve({ success: false, errors: [{ message: error.message || 'Failed to create user' }] });
      });
    });
  }

  static async loinSocial(data = {}) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: 'user/loinSocial',
        data
      }).then((result = {}) => {
        return resolve(result);
      });
    });
  }

  static async adminLogin(email, password) {
    return new Promise((resolve) => {
      Request.send({
        method: 'POST',
        path: 'admin/login',
        data: {
          email,
          password
        },
        
      }).then((result = {}) => {
        console.log('Admin login response:', result);
        return resolve(result);
      }).catch((error) => {
        console.error('Admin login error:', error);
        return resolve({ success: false, errors: [{ message: error.message || 'Login failed' }] });
      });
    });
  }

  static async getListUser(query = {}) {
    return new Promise((resolve) => {
      Request.send({
        method: 'GET',
        path: 'admin/users',
        query
      }).then((result = {}) => {
        console.log('User list response:', result);
        
        // Handle nested response structure if present
        if (result.success && result.data && Array.isArray(result.data)) {
          return resolve({
            success: true,
            data: result.data,
            pagination: result.pagination,
            message: result.message
          });
        }
        
        return resolve(result);
      }).catch((error) => {
        console.error('User list error:', error);
        return resolve({ success: false, errors: [{ message: error.message || 'Failed to fetch users' }] });
      });
    });
  }

  static async getById(id) {
    return new Promise((resolve) => {
      Request.send({
        method: 'GET',
        path: `admin/users/${id}`
      }).then((result = {}) => {
        console.log('User detail response:', result);
        return resolve(result);
      }).catch((error) => {
        console.error('User detail error:', error);
        return resolve({ success: false, errors: [{ message: error.message || 'Failed to fetch user' }] });
      });
    });
  }

  static async update(id, data = {}) {
    return new Promise((resolve) => {
      Request.send({
        method: 'PUT',
        path: `admin/users/${id}`,
        data
      }).then((result = {}) => {
        console.log('User update response:', result);
        return resolve(result);
      }).catch((error) => {
        console.error('User update error:', error);
        return resolve({ success: false, errors: [{ message: error.message || 'Failed to update user' }] });
      });
    });
  }

  static async delete(id) {
    return new Promise((resolve) => {
      Request.send({
        method: 'DELETE',
        path: `admin/users/${id}`
      }).then((result = {}) => {
        console.log('User delete response:', result);
        
        // Handle HTTP 204 No Content or success responses
        if (result.success || result.statusCode === 204) {
          return resolve({
            success: true,
            message: result.message || 'User deleted successfully'
          });
        }
        
        return resolve(result);
      }).catch((error) => {
        console.error('User delete error:', error);
        return resolve({ success: false, errors: [{ message: error.message || 'Failed to delete user' }] });
      });
    });
  }
}
